import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import styled from 'styled-components';
var StyledLayout = styled.a.withConfig({
    displayName: "CloseBtn__StyledLayout",
    componentId: "sc-13f4bm4-0"
})([
    "display:inline-block;font-size:0;cursor:pointer;svg{color:#a7a7b4;}"
]);
export default function CloseBtn(props) {
    var className = props.className, onClick = props.onClick, style = props.style;
    return(/*#__PURE__*/ _jsx(StyledLayout, {
        className: "".concat(className || ''),
        onClick: onClick,
        style: style,
        children: /*#__PURE__*/ _jsx("svg", {
            xmlns: "//www.w3.org/2000/svg",
            width: "18",
            height: "18",
            viewBox: "0 0 20 20",
            children: /*#__PURE__*/ _jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M19.3 1.332A.773.773 0 0 0 19.28.22a.823.823 0 0 0-1.142.021L9.763 8.726 1.39.241A.823.823 0 0 0 .248.22a.773.773 0 0 0-.022 1.112l8.417 8.53L.226 18.39c-.31.314-.3.812.022 1.113.156.147.358.22.56.22a.818.818 0 0 0 .581-.242l8.374-8.484 8.373 8.485c.159.16.37.241.583.241a.818.818 0 0 0 .56-.22c.32-.3.33-.799.02-1.112l-8.416-8.53 8.418-8.529z"
            })
        })
    }));
};
